import { render, staticRenderFns } from "./CreateProductDialog.vue?vue&type=template&id=1012519c&scoped=true&"
import script from "./CreateProductDialog.vue?vue&type=script&lang=js&"
export * from "./CreateProductDialog.vue?vue&type=script&lang=js&"
import style0 from "./CreateProductDialog.vue?vue&type=style&index=0&id=1012519c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1012519c",
  null
  
)

export default component.exports